import { render, staticRenderFns } from "./ClientMaterialGroupSettings.vue?vue&type=template&id=3edd6f97&"
import script from "./ClientMaterialGroupSettings.js?vue&type=script&lang=js&"
export * from "./ClientMaterialGroupSettings.js?vue&type=script&lang=js&"
import style0 from "./ClientMaterialGroupSettings.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports